import React from 'react';
import type { GenericSectionContent } from './types';
import HeroBannerRendering from './renderings/hero-banner';
import OrionRendering from './renderings/orion';
import LyraRendering from './renderings/lyra';
import VegaRendering from './renderings/vega';
import AtlasRendering from './renderings/atlas';
import CygnusRendering from './renderings/cygnus';
import NovaRendering from './renderings/nova';
import MesaRendering from './renderings/mesa';
import SolisRendering from './renderings/solis';
import CarinaRendering from './renderings/carina';
import FAQsRendering from './renderings/faqs';
import FAQGroupsRendering from './renderings/faq-groups';
import VortexRendering from './renderings/vortex';
import NexusRendering from './renderings/nexus';
import QuasarRendering from './renderings/quasar';
import HtmlOnlyRendering from './renderings/html-only';
import ChronosRendering from './renderings/chronos';

const RenderingRegistry: { [key: string]: React.ElementType } = {
  "Hero Banner": HeroBannerRendering,
  "Orion": OrionRendering,
  "Lyra": LyraRendering,
  "Vega": VegaRendering,
  "Atlas": AtlasRendering,
  "Cygnus": CygnusRendering,
  "Nova": NovaRendering,
  "Mesa": MesaRendering,      // category listing header  (/tapware-and-accessories/basin-mixers/)
  "Solis": SolisRendering,    // collection listing header (/collection/kiri/)
  "Carina": CarinaRendering,  // image + copy body row     (/our-story/, /experience-centres/)
  "FAQs": FAQsRendering,
  "FAQ Groups": FAQGroupsRendering,
  "Vortex": VortexRendering,
  "Nexus": NexusRendering,
  "Quasar": QuasarRendering,  // technology grid, full bleed (/our-technologies/)
  "Chronos": ChronosRendering,
  "Lumen": HtmlOnlyRendering,        // keep — existing entries still resolve
  "HTML Only": HtmlOnlyRendering,    // new — authors pick this going forward
};

export default function GenericSection({ content }: { content: GenericSectionContent }) {
  const Rendering = RenderingRegistry[content.rendering_type];
  if (!Rendering) {
    console.error(`GenericSection: unknown rendering_type "${content.rendering_type}"`);
    return null;
  }
  return <Rendering content={content} />;
}
